/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_checkout_success_message = /** @type {(inputs: {}) => string} */ () => {
	return `Děkujeme za vaši objednávku. Vaše platba byla úspěšně zpracována.`
};

const da_checkout_success_message = /** @type {(inputs: {}) => string} */ () => {
	return `Tak for din ordre. Din betaling er gennemført.`
};

const de_checkout_success_message = /** @type {(inputs: {}) => string} */ () => {
	return `Vielen Dank für Ihre Bestellung. Ihre Zahlung wurde erfolgreich verarbeitet.`
};

const en_checkout_success_message = /** @type {(inputs: {}) => string} */ () => {
	return `Thank you for your order. Your payment has been successfully processed.`
};

const es_checkout_success_message = /** @type {(inputs: {}) => string} */ () => {
	return `Gracias por tu pedido. Tu pago se ha procesado correctamente.`
};

const fr_checkout_success_message = /** @type {(inputs: {}) => string} */ () => {
	return `Merci pour votre commande. Votre paiement a été traité avec succès.`
};

const hu_checkout_success_message = /** @type {(inputs: {}) => string} */ () => {
	return `Köszönjük a rendelésed. A fizetésed sikeresen feldolgozásra került.`
};

const it_checkout_success_message = /** @type {(inputs: {}) => string} */ () => {
	return `Grazie per il tuo ordine. Il pagamento è stato elaborato con successo.`
};

const nl_checkout_success_message = /** @type {(inputs: {}) => string} */ () => {
	return `Bedankt voor je bestelling. Je betaling is succesvol verwerkt.`
};

const pl_checkout_success_message = /** @type {(inputs: {}) => string} */ () => {
	return `Dziękujemy za zamówienie. Twoja płatność została pomyślnie przetworzona.`
};

const pt_checkout_success_message = /** @type {(inputs: {}) => string} */ () => {
	return `Obrigado pelo seu pedido. Seu pagamento foi processado com sucesso.`
};

const sv_checkout_success_message = /** @type {(inputs: {}) => string} */ () => {
	return `Tack för din beställning. Din betalning har behandlats.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const checkout_success_message = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.checkout_success_message(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("checkout_success_message", locale)
	if (locale === "cs") return cs_checkout_success_message(inputs)
	if (locale === "da") return da_checkout_success_message(inputs)
	if (locale === "de") return de_checkout_success_message(inputs)
	if (locale === "en") return en_checkout_success_message(inputs)
	if (locale === "es") return es_checkout_success_message(inputs)
	if (locale === "fr") return fr_checkout_success_message(inputs)
	if (locale === "hu") return hu_checkout_success_message(inputs)
	if (locale === "it") return it_checkout_success_message(inputs)
	if (locale === "nl") return nl_checkout_success_message(inputs)
	if (locale === "pl") return pl_checkout_success_message(inputs)
	if (locale === "pt") return pt_checkout_success_message(inputs)
	return sv_checkout_success_message(inputs)
};
export { checkout_success_message as "checkout.success_message" }